import React, { useEffect, useMemo, useRef, useState } from 'react';
import cx from 'classnames';
import styles from './EngageSidebar.module.scss';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { Icon } from '../Icon';
import useOutsideClick from '../../../common/hooks/useOutsideClick';
import { CustomButton } from '../Button/Button';
import { ToastNotification } from '../Toast/Toast';

const ChangeLanguage = props => {
  const { languages, language, setLanguage, isLanguageMenu, setIsLanguageMenu, setIsOpenMenu, isMobileView, className } = props;

  const { t } = useTranslation();
  const rootRef = useRef(null);
  const [tempLanguage, setTempLanguage] = useState('');

  useOutsideClick(rootRef, () => {
    if (isLanguageMenu) {
      setOldLanguage();
    }
  });

  useEffect(() => {
    i18next.changeLanguage(tempLanguage.lng);
  }, [tempLanguage]);

  useEffect(() => {
    i18next.changeLanguage(language.lng);
  }, [language]);

  function saveNewLanguage() {
    setLanguage(tempLanguage);
    setIsLanguageMenu(false);
    const extensionId = process.env.EXT_ID;
    window.postMessage({ type: extensionId, message: 'SAVE_LANGUAGE', language: tempLanguage.lng }, '*');
    setTempLanguage('');
    ToastNotification({
      message: t('general.toast.changed_language'),
      iconName: 'success',
      isMobileView: isMobileView,
    });
  }

  function setOldLanguage() {
    //If new Language is not saved, change back to the old one
    setIsLanguageMenu(false);
    setTempLanguage('');
    i18next.changeLanguage(language.lng);
  }

  return (
    <>
      <div className={cx(styles.languageContainer, className)} ref={rootRef}>
        <div className={styles.header}>
          <h1>{t('account.settings.languages')}</h1>
          <Icon
            className={styles.closeIcon}
            onClick={() => {
              setOldLanguage();
            }}
            src="close"
          />
        </div>
        <ul className={styles.sectionList}>
          {languages.map(item => (
            <li onClick={() => setTempLanguage(item)} key={item.name}>
              {item?.flagPath && <Icon src={item?.flagPath} className={styles.languageIcon} />}
              <span className={styles.languageItem}>{item.name}</span>
            </li>
          ))}
        </ul>
        <div className={styles.buttonContainer}>
          <CustomButton
            label={t('general.cancel')}
            variant="secondary"
            onClick={() => {
              setOldLanguage();
              setIsOpenMenu && setIsOpenMenu(true);
            }}
            className={`${styles.pageButtons}, ${styles.cancelButton}`}
          />
          <CustomButton label={t('general.save')} variant="primary" onClick={() => saveNewLanguage()} className={styles.pageButtons} />
        </div>
      </div>
    </>
  );
};

export default ChangeLanguage;
